export function omitEmptyValuesProp(obj) {
  Object.keys(obj).forEach(key => {
    const value = obj[key];
    if (
      value === undefined || 
      value === null || 
      value === '' || 
      (Array.isArray(value) && value.length === 0) || 
      (typeof value === 'object' && value !== null && Object.keys(value).length === 0)
    ) {
      delete obj[key];
    }
  });
  return obj;
}
